import React from 'react';
import { Header, Footer } from '../../component/index';

const DataForRest = () => {
    return (
        <table className="table">
            <thead>
                <tr>
                    <th></th>
                    <th>Basic Edition</th>
                    <th>NAS Edition</th>
                    <th>Windows Server Edition</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th scope="row">伺服器</th>
                    <td data-head="Basic Edition">註冊即可使用</td>
                    <td data-head="NAS Edition">NAS伺服器</td>
                    <td data-head="Windows Server Edition">企業本身的伺服器</td>
                </tr>
                <tr>
                    <th scope="row">人數(可加購)</th>
                    <td data-head="Basic Edition">Win/Mac/Web. iOS/Android</td>
                    <td data-head="NAS Edition">Win/Mac/Web. iOS/Android</td>
                    <td data-head="Windows Server Edition">Win/Mac/Web. iOS/Android</td>
                </tr>
                <tr>
                    <th scope="row">支援平台</th>
                    <td data-head="Basic Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="NAS Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">多語辨識</th>
                    <td data-head="Basic Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="NAS Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">權限管理</th>
                    <td data-head="Basic Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="NAS Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">名片共享給同事</th>
                    <td data-head="Basic Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="NAS Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">幫同事/主管掃描</th>
                    <td data-head="Basic Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="NAS Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">導出CRM或Excel</th>
                    <td data-head="Basic Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="NAS Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">限制特定IP登入</th>
                    <td data-head="Basic Edition"></td>
                    <td data-head="NAS Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">提供WEB API整合CRM</th>
                    <td data-head="Basic Edition"></td>
                    <td data-head="NAS Edition"></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">付費方式</th>
                    <td data-head="Basic Edition">軟體每年付費</td>
                    <td data-head="NAS Edition">軟體買斷</td>
                    <td data-head="Windows Server Edition">軟體買斷</td>
                </tr>
                <tr>
                    <th scope="row">包裝內容</th>
                    <td data-head="Basic Edition">
                        <div className="flex-container">
                            <ul className="table-list">
                                <li>軟體</li>
                                <li>啟動需知</li>
                                <li>用戶授權 x2</li>
                                <li>快速使用指南</li>
                                <li>名片掃描器 x1</li>
                            </ul>
                        </div>
                    </td>
                    <td data-head="NAS Edition">
                        <div className="flex-container">
                            <ul className="table-list">
                                <li>軟體</li>
                                <li>啟動需知</li>
                                <li>用戶授權 x2</li>
                                <li>快速使用指南</li>
                                <li>名片掃描器 x1</li>
                            </ul>
                        </div>
                    </td>
                    <td data-head="Windows Server Edition">
                        <div className="flex-container">
                            <ul className="table-list">
                                <li>軟體</li>
                                <li>啟動需知</li>
                                <li>用戶授權 x10</li>
                                <li>快速使用指南</li>
                            </ul>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    )
}
const DataForTaiwan = () => {
    return (
        <table className="table">
            <thead>
                <tr>
                    <th></th>
                    <th>Basic Edition</th>
                    <th>Windows Server Edition</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th scope="row">伺服器</th>
                    <td data-head="Basic Edition">註冊即可使用</td>
                    <td data-head="Windows Server Edition">企業本身的伺服器</td>
                </tr>
                <tr>
                    <th scope="row">人數(可加購)</th>
                    <td data-head="Basic Edition">Win/Mac/Web. iOS/Android</td>
                    <td data-head="Windows Server Edition">Win/Mac/Web. iOS/Android</td>
                </tr>
                <tr>
                    <th scope="row">支援平台</th>
                    <td data-head="Basic Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">多語辨識</th>
                    <td data-head="Basic Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">權限管理</th>
                    <td data-head="Basic Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">名片共享給同事</th>
                    <td data-head="Basic Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">幫同事/主管掃描</th>
                    <td data-head="Basic Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">導出CRM或Excel</th>
                    <td data-head="Basic Edition"><i className="mdi mdi-check text-check"></i></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">限制特定IP登入</th>
                    <td data-head="Basic Edition"></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">提供WEB API整合CRM</th>
                    <td data-head="Basic Edition"></td>
                    <td data-head="Windows Server Edition"><i className="mdi mdi-check text-check"></i></td>
                </tr>
                <tr>
                    <th scope="row">付費方式</th>
                    <td data-head="Basic Edition">軟體每年付費</td>
                    <td data-head="Windows Server Edition">軟體買斷</td>
                </tr>
                <tr>
                    <th scope="row">包裝內容</th>
                    <td data-head="Basic Edition">
                        <div className="flex-container">
                            <ul className="table-list">
                                <li>軟體</li>
                                <li>啟動需知</li>
                                <li>用戶授權 x2</li>
                                <li>快速使用指南</li>
                                <li>名片掃描器 x1</li>
                            </ul>
                        </div>
                    </td>
                    <td data-head="Windows Server Edition">
                        <div className="flex-container">
                            <ul className="table-list">
                                <li>軟體</li>
                                <li>啟動需知</li>
                                <li>用戶授權 x10</li>
                                <li>快速使用指南</li>
                            </ul>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>        
    )
}
const Solutions = () => {
    const isLocatedTW = localStorage.getItem('isLocatedTW')
    return (
        <>
        <Header homepage={false} />
        <div className="wrapper">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="page-title-box">
                            <h4 className="page-title">Solutions</h4>
                        </div>
                    </div>
                </div>
                <div className="flex-container">
                    <div className="row">
                        <div className="title_underline"></div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <h4 className="header-title-sm">如果您不知道如何選擇，請<a href="/contact">連繫我們</a></h4>
                </div>
                <div className="row justify-content-center m-t-50 m-b-50">
                    { isLocatedTW ? <DataForTaiwan/> : <DataForRest/> }
                </div>
            </div>
            <div className="above-footer"></div> 
        </div>
        <Footer/>
        </>
    )
}

export default Solutions;